export default __webpack_public_path__ + "static/media/about-image-01.e6cc5f5c.png";